import { BUTTON_ACTIONS } from '@text-content/button-templates';

const moveItemsHelper = {
  [BUTTON_ACTIONS.MOVE_TO_TOP]: (selected, other): any[] => [
    ...selected,
    ...other,
  ],
  [BUTTON_ACTIONS.MOVE_TO_BOTTOM]: (selected, other): any[] => [
    ...other,
    ...selected,
  ],
};

export { moveItemsHelper };
